import { AppConfig } from '@/types/config';

export * from './TaleemXMark';
export * from './TaleemXWordmark';
export * from './TaleemXBootSplash';

/**
 * Checks whether the current school branding is using default TaleemX / AMS branding
 * or has a custom school crest configured.
 *
 * Practical rule:
 * - If school_logo_url is missing OR equals /logo-taleem.png, /logo-pen.svg, /logo-mark.svg, /logo.png, /logo-taleemx.svg
 *   -> default branding (use mark + TaleemX wordmark)
 * - Else -> custom school crest + custom school_name
 */
export function isDefaultBranding(config?: AppConfig | { school_logo_url?: string; school_name?: string } | null): boolean {
  if (!config) return true;
  const logo = config.school_logo_url;
  if (!logo) return true;

  const defaultLogos = [
    '/logo-taleem.png',
    '/logo-taleem.jpg',
    '/logo-pen.svg',
    '/logo-mark.svg',
    '/logo-taleemx.svg',
    '/logo.png',
    '/favicon.svg',
  ];

  return defaultLogos.includes(logo);
}
